var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 58",
    width: 58,
    height: 58,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m38.7 26.7l-0.5 3.7c-0.1 0.6-0.6 1.1-1.2 1.1h-6v15.5q-1 0.1-1.9 0.1-2.2 0-4.3-0.5v-15.1h-4.6c-0.4 0-0.8-0.4-0.8-0.8v-4.6c0-0.5 0.4-0.8 0.8-0.8h4.6v-7c0-4.3 3.5-7.7 7.7-7.7h5.4c0.4 0 0.8 0.3 0.8 0.7v4.7c0 0.4-0.4 0.8-0.8 0.8h-3.8c-1.7 0-3.1 1.4-3.1 3.1v5.4h6.5c0.7 0 1.3 0.6 1.2 1.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "a",
    d: "m45.4 57.5h-32.7c-6.8 0-12.3-5.5-12.3-12.3v-32.8c0-6.7 5.5-12.2 12.3-12.2h32.7c6.8 0 12.3 5.5 12.3 12.2v32.8c0 6.8-5.5 12.3-12.3 12.3zm-32.7-55.1c-5.6 0-10.1 4.5-10.1 10v32.8c0 5.5 4.5 10 10.1 10h32.7c5.6 0 10.1-4.5 10.1-10v-32.8c0-5.5-4.5-10-10.1-10z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.586779828ec358a0bccdf54db366cdd7.svg";
export { ForwardRef as ReactComponent };